import { render, staticRenderFns } from "./FeTableColumn.vue?vue&type=template&id=bf760bdc&"
import script from "./FeTableColumn.vue?vue&type=script&lang=js&"
export * from "./FeTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports